<template>
  <div>
    <span v-if="isHeaderVisible">
      <span class="small-text">{{ $getText('PRESENCE_REPORT_ABSENCE') }}</span>
      <div class="border-bottom" />
    </span>
    <div class="presence-icons">
      <div v-if="isSickSettingVisible" class="presence-icon-container">
        <IconContainer
          v-button
          class="icon-circle"
          :class="{
            disabled: !configuration[presenceModules.REPORT_SICK].editable,
            active: status == presenceStates.SICK,
          }"
          @click="updateChildStatus(status != presenceStates.SICK ? presenceStates.SICK : presenceStates.PRESENT)"
        >
          <Icon :name="iconClassEnum.SYG_IKON" />
        </IconContainer>
        <div class="icons-description">
          {{ $getText('PRESENCE_SICK') }}
        </div>
      </div>
      <div v-if="isVacationSettingVisible" class="presence-icon-container">
        <IconContainer
          v-button
          class="icon-circle"
          :class="{
            disabled: !configuration[presenceModules.VACATION].editable,
            active: showVacationForm || status == presenceStates.REPORTED_ABSENT,
          }"
          @click="showVacation"
        >
          <Icon :name="iconClassEnum.FERIE_IKON" />
        </IconContainer>
        <div class="icons-description">
          {{ $getText('PRESENCE_VACATION') }}
        </div>
      </div>
      <vacation-form
        v-if="isVacationFormVisible"
        :child-ids="childIds"
        :is-disabled-start-date="false"
        @updateChildStatus="updateChildStatus"
        @saveVacation="saveVacation"
        @cancelVacationForm="showVacationForm = !showVacationForm"
      />
      <div v-else-if="vacationNote" class="vacation-note">
        <div class="title">{{ $t('presence.vacation_free_time_note') }}</div>
        <div class="note">{{ vacationNote }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { presenceStates } from '../../enums/presenceStates';
import { presenceModules } from '../../enums/presenceModules';
import VacationForm from './VacationForm';
import IconContainer from '../IconContainer.vue';
import Icon from '../Icon.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';
import button from '../../directives/button';

export default {
  components: {
    Icon,
    IconContainer,
    VacationForm,
  },
  directives: {
    button,
  },
  props: {
    childIds: { type: Array },
    status: { type: Number },
    configuration: { type: Object, default: () => {} },
    vacationNote: { type: String, default: '' },
  },
  data: function () {
    return {
      presenceStates: presenceStates,
      presenceModules: presenceModules,
      showVacationForm: false,
    };
  },
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
    isSickSettingVisible() {
      return (
        this.configuration[presenceModules.REPORT_SICK] != null &&
        this.configuration[presenceModules.REPORT_SICK].readable
      );
    },
    isVacationSettingVisible() {
      return (
        this.configuration[presenceModules.VACATION] != null && this.configuration[presenceModules.VACATION].readable
      );
    },
    isVacationFormVisible() {
      return this.showVacationForm && this.configuration[presenceModules.VACATION].editable;
    },
    isHeaderVisible() {
      return this.isVacationFormVisible || this.isVacationSettingVisible || this.isSickSettingVisible;
    },
  },
  methods: {
    showVacation() {
      if (this.configuration[presenceModules.VACATION].editable) {
        this.showVacationForm = !this.showVacationForm;
      }
    },
    updateChildStatus(status) {
      if (this.configuration[presenceModules.REPORT_SICK].editable) {
        this.$emit('updateChildStatus', status, true);
      }
    },
    saveVacation() {
      this.$emit('saveVacation');
    },
  },
};
</script>
<style lang="scss" scoped>
@use '../../assets/scss/core/variables' as *;
@use '../../assets/scss/core/breakpoints' as *;
@use '../../assets/scss/components/presence/presence-checkin-dashboard' as *;
</style>
